export enum CompanySize {
  Range1 = 'range_1',
  Range2To5 = 'range_2_to_5',
  Range6To10 = 'range_6_to_10',
  Range11To20 = 'range_11_to_20',
  MoreThan20 = 'more_than_20',
}
